import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { NewExperienceBannerActions } from '../../actions/new-experience.actions';

@Component({
  selector: 'app-new-experience-dialog',
  templateUrl: './new-experience-dialog.component.html',
  styleUrls: ['./new-experience-dialog.component.scss'],
})
export class NewExperienceDialogComponent {
  readonly previewImageSrc = 'assets/new-experience/new-experience-preview.png';

  constructor(
    private readonly dialogRef: MatDialogRef<NewExperienceDialogComponent>,
    private readonly store: Store,
  ) {}

  tryNewExperience(): void {
    this.store.dispatch(
      NewExperienceBannerActions.tryNewExperienceClicked({ source: 'dialog' }),
    );
    this.dialogRef.close();
  }

  close(): void {
    this.dialogRef.close();
  }
}
